import Icon from 'veui/components/Icon'
import { IconShieldCheck } from 'dls-icons-vue'

Icon.register('shield-check', IconShieldCheck)
